export const getConsumerGroups = (state) => state.consumerGroups.data;
export const getIsLoading = (state) => state.consumerGroups.isLoading;
export const getIsResetModalOpen = (state) => state.consumerGroups.isResetModalOpen;
export const getActiveConsumerGroupId = (state) => state.consumerGroups.activeConsumerGroupId;
export const getError = (state) => state.consumerGroups.error;
export const getIsResultModalOpen = (state) => state.consumerGroups.isResultModalOpen;
